import React from 'react'
import { IMenuOption } from '../../../models'
import StyledLi from './styles'

interface IProps {
  option: IMenuOption
  onClick?: () => void
}

export const Option: React.FC<IProps> = ({ option, onClick }) => {
  const handleClick = () => {
    if (option.action && typeof option.action === 'function' )option.action()
    if (onClick && typeof onClick === 'function') onClick()
  }

  return (
    <StyledLi className={ option.isDisabled ? 'disabled' : '' } onClick={ handleClick }>
      {/* <Icon icon={ option.icon } /> */}
      <span>{ option.label }</span>
    </StyledLi>
  )
}
